import { supabase } from './supabase'
import type { Escola, ZonaTipo } from '../types/database'

/** Campos graváveis pela RPC `salvar_escola_com_responsaveis`. */
export type EscolaRpcPayload = {
  nome: string
  endereco?: string | null
  bairro?: string | null
  zona?: ZonaTipo | string | null
  infantil_m?: number
  infantil_t?: number
  infantil_n?: number
  infantil_i?: number
  fund_menor_m?: number
  fund_menor_t?: number
  fund_menor_n?: number
  fund_menor_i?: number
  fund_maior_m?: number
  fund_maior_t?: number
  fund_maior_n?: number
  fund_maior_i?: number
  eja_m?: number
  eja_t?: number
  eja_n?: number
  eja_i?: number
  alunos_pre?: number
  alunos_fund1?: number
  alunos_fund2?: number
  alunos_eja?: number
  alunos_integral?: number
  turnos_manuais?: boolean
  atualizado_em?: string
}

export type SalvarEscolaComResponsaveisResult = {
  id: string
}

export type SalvarEscolaComResponsaveisInput = {
  escolaId: string | null
  escola: EscolaRpcPayload
  responsavelIds?: string[]
  /** Quando false, só grava a escola (não apaga/recria vínculos). Default: true. */
  sincronizarResponsaveis?: boolean
}

/**
 * Insere ou atualiza escola e sincroniza `escola_responsaveis` em uma transação.
 * Substitui o delete/insert encadeado no cliente (US-R03 / A3).
 */
export async function salvarEscolaComResponsaveis(
  input: SalvarEscolaComResponsaveisInput,
): Promise<SalvarEscolaComResponsaveisResult> {
  const nome = input.escola.nome?.trim()
  if (!nome) throw new Error('Nome é obrigatório')

  const sincronizar = input.sincronizarResponsaveis !== false
  const responsavelIds = sincronizar
    ? (input.responsavelIds ?? []).filter((id) => !!id)
    : []

  const { data, error } = await supabase.rpc('salvar_escola_com_responsaveis', {
    p_escola_id: input.escolaId,
    p_escola: { ...input.escola, nome },
    p_responsavel_ids: responsavelIds,
    p_sincronizar_responsaveis: sincronizar,
  })

  if (error) throw new Error(error.message)

  const row = data as { id?: string } | null
  const id = row?.id
  if (!id) throw new Error('Erro ao gravar escola')

  return { id }
}

/** Monta o payload da RPC a partir do formulário de cadastro. */
export function montarPayloadEscolaForm(params: {
  nome: string
  endereco: string
  bairro: string
  zona: ZonaTipo
  turnos: Partial<Escola>
  turnosManuais?: boolean
}): EscolaRpcPayload {
  return {
    nome: params.nome.trim(),
    endereco: params.endereco || null,
    bairro: params.bairro || null,
    zona: params.zona,
    ...params.turnos,
    turnos_manuais: params.turnosManuais ?? true,
    atualizado_em: new Date().toISOString(),
  }
}
